<template lang="pug">
  .height-100
    transition(name="fade")
      delegaciones-informe(v-if="modalInforme", @close="closeModalInforme", :id="informe.id")
    transition(name="fade")
      .modal.is-active(key="modal-editar",v-if="mostrarModalEditar", :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
        .modal-background
        gestion-delegaciones-rrhh-guardar(
          :info="info"
          @close="closeModalEditar",
          @closeRefresh="closeModalEditar(true)"
        )
    transition(name='fade')
      .modal.is-active(key="modal-inactivar",v-if="modalConfirmacionInactivar", :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
        .modal-background
        .card
          header.card-header
            p.card-header-title
              span Inactivar delegación
            a.card-header-icon
              span.icon
                button.delete(@click="modalConfirmacionInactivar = false")
          .card-content
            .content
              strong ¿Estás seguro de inactivar la delegación?
          footer.card-footer
            a.card-footer-item.is-success(@click="inactivar")
                span(v-if="isLoading") Inactivando...
                span(v-else) Inactivar
            a.card-footer-item( @click="modalConfirmacionInactivar = false")
              strong Cancelar
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Gestion de delegaciones RRHH
        .text-right
          //- checkbox que indique inactivo o activo
          label.mr-2 Ver inactivas
          input.mr-8(type="checkbox", v-model="verInactivas", @input="handlerVerInactivas")
          button.button.is-small.margin-right-5.is-primary(@click="openModalEditar('')")
            span.icon.is-small
              i.fa.fa-plus
            span Nuevo
          button.button.is-small(@click="fetch")
            span.icon.is-small
              i.fa.fa-refresh
            span Refrescar
        //- .show-closed-text
        //-   span(
        //-     @click="showClosed = !showClosed"
        //-   )
        //-     template(v-if="showClosed") Mostrando todas delegaciones
        //-     template(v-else) Mostrando solo las delegaciones abiertas
        .body
          .information
            transition-group.contenedor-data(
              v-infinite-scroll="fetchByScroll"
              infinite-scroll-disabled="disabledScrollExecute"
              infinite-scroll-distance="2"
              name="fade-smooth-two"
              tag="div"
            )
              .tabla(key="table-delegaciones-rrhh")
                table.table.is-striped.is-bordered(
                  v-if="lista.length !== 0"
                )
                  thead
                    th Empleado
                    th.hide-break-1 Reemplazante
                    th Fecha
                    th.hide-break-1 Creación
                    th
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                      :class="{'is-close': !o.activo}"
                    )
                      td
                        .hint--top(:aria-label="'Empleado: ' + o.dniEmpleadoOrigen")
                          .td-wrapper
                            span {{ o.nombreEmpleadoOrigen }}
                            strong.show-break-1 Reemplazo:
                            span.show-break-1.hint--bottom(:aria-label="'Reemplazante: ' + o.dniEmpleadoReemplazante") {{ o.nombreEmpleadoReemplazante }}
                      td.hide-break-1
                        .hint--top(:aria-label="'Reemplazante: ' + o.dniEmpleadoReemplazante")
                          span {{ o.nombreEmpleadoReemplazante }}
                      td
                        .td-wrapper
                          //- span {{ o.fechaInicioString == o.fechaFinString ? o.fechaInicioString : o.fechaInicioString + ' - ' + o.fechaFinString }}
                          span(v-if="o.fechaInicioString == o.fechaFinString") {{ o.fechaInicioString }}
                          .fechas(v-else)
                            span {{ o.fechaInicioString }}
                            span.hide-break-guion -
                            span {{ o.fechaFinString }}
                          strong.show-break-1 Creado:
                          span.show-break-1 {{ o.creado }}
                      td.hide-break-1 {{ o.creado }}
                      td.text-center
                        .td-wrapper
                          .contenedor-acciones
                            button.button.is-small.mt-10(@click="openModalEditar(o.id)", v-if="o.activo")
                              span.icon.is-small
                                i.fa.fa-pencil-square-o
                              span Editar
                            //- button.button.is-small.is-danger.mt-10(@click="abrirModalInactivar(o)", v-if="o.activo")
                            button.button.is-small.is-danger.mt-10(@click="abrirModalInactivar(o)")
                              span.icon.is-small
                                i.fa.fa-times
                              span Inactivar
                            button.button.is-small.mt-10(@click="abrirModalInforme(o)")
                              span.icon.is-small
                                i.fa.fa-eye
                              span Informe
                .is-loading(v-if="isLoading")
                  .icon
                    i.fa.fa-spinner.fa-spin
                .message.is-warning(v-if="lista.length === 0 && !isLoading", key="message")
                  .message-body
                    span.has-text-bold No existe información con los filtros definidos
</template>

<script>
import { apiGet, notify, apiPost } from '../util/general'
import moment from 'moment'
import GestionDelegacionGuardar from './c_gestion_delegaciones_rrhh_guardar'
import ComponentDelegacionesInforme from './Component_Delegaciones_Informe.vue';
export default {
  name: 'gestion-delegaciones-rrhh',
  components: {
    'gestion-delegaciones-rrhh-guardar': GestionDelegacionGuardar,
    'delegaciones-informe': ComponentDelegacionesInforme
  },
  data () {
    return {
      lista : [],
      isLoading: false,
      info: {},
      mostrarModalEditar: false,
      showClosed: false,
      codigoEmpleado : localStorage.getItem('codigo'),
      verInactivas: false,
      disabledScrollExecute : true,
      modalConfirmacionInactivar: false,
      modalInforme: false,
      isScroll : true,
      skip                   : 0,
      noMore                 : false,
      objInactivar           : {},
      informe                : {}
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    abrirModalInactivar (o) {
      this.objInactivar = o
      this.modalConfirmacionInactivar = true
    },
    abrirModalInforme (o) {
      this.informe = o
      this.modalInforme = true
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    handlerVerInactivas () {
      this.verInactivas = !this.verInactivas
      this.fetch()
    },
    inactivar () {
      var vm = this
      if (vm.isLoading) return;
      vm.isLoading = true
      var obj = {
        fechaInicio                 : vm.objInactivar.fechaInicio,
        fechaFin                    : vm.objInactivar.fechaFin,
        codigoEmpleadoOrigen        : vm.objInactivar.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante  : vm.objInactivar.codigoEmpleadoReemplazante,
        activo                      : 0,
        id                          : vm.objInactivar.id
      }
      apiPost(vm, '/delegaciones', obj, function (data) {
        if (data.estoyReemplazando || data.estoySiendoReemplazado) {
          vm.$store.dispatch('setEstoyReemplazando', false)
          vm.$store.dispatch('setEstoySiendoReemplazado', false)
          vm.$store.dispatch('setNombreReemplazo', '')
        }
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        if (+obj.codigoEmpleadoOrigen === +vm.codigoEmpleado || +obj.codigoEmpleadoReemplazante === +vm.codigoEmpleado) {
          window.location.reload()
        } else {
          vm.isLoading = false
          vm.modalConfirmacionInactivar = false
          vm.fetch()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      var obj = {
      }
      if (vm.verInactivas) {
        obj.activo = 0
      } else {
        obj.activo = 1
      }
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/delegaciones', obj, function (data) {
        data.lista.forEach(function (o) {
          o.creado = moment(o.creado).format('DD/MM/YYYY HH:mm')
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    openModalEditar (id) {
      var vm = this
      if (id) {
        let obj = vm.lista.find((o) => o.id === id)
        vm.info = {
          id: obj.id,
          fechaInicio: moment(obj.fechaInicio).format('YYYY-MM-DD'),
          fechaFin: moment(obj.fechaFin).format('YYYY-MM-DD'),
          codigoEmpleadoOrigen: obj.codigoEmpleadoOrigen,
          codigoEmpleadoReemplazante: obj.codigoEmpleadoReemplazante,
          activo: obj.activo
        }
      }
      vm.mostrarModalEditar = true
    },
    closeModalEditar (refresh) {
      var vm = this
      vm.mostrarModalEditar = false
      vm.info = {}
      if (refresh) vm.fetch()
    },
    closeModalInforme () {
      this.modalInforme = false
    }
  }
}
</script>
<style lang="stylus" scoped>
  .mr-8
    margin-right 8px !important
    vertical-align: middle !important
  .mr-2
    margin-right 2px !important
    vertical-align: middle !important
  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  .show-break-1
    display none

  @media (max-width: 1091px)
    .fechas
      display: flex
      flex-direction: column
      align-items: center
      span
        margin-bottom: 5px

    .hide-break-guion
      display none

  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width 600px)
    .table
      font-size 12px
      .td-wrapper
        display flex
        justify-content: center
        align-items: baseline
        flex-direction: column
        .contenedor-acciones
          flex-direction: column
          .button
            margin-bottom 5px
            &:last-child
              margin-bottom 0px
  @media (max-width: 540px)
    .hide-break-1
      display none

    .show-break-1
      display block


</style>




// WEBPACK FOOTER //
// Component_Gestion_Delegaciones_RRHH.vue?0963a092